import { z } from 'zod';

import { dateString } from '@/lib/zod';

export const DateOnlySchema = dateString('Date is required');
export type DateOnly = z.infer<typeof DateOnlySchema>;

export enum WorkItemType {
    Contracted = 0,
    Variation = 1,
    TrackerTask = 2,
}
export const WorkItemTypeSchema = z.enum(WorkItemType);

export enum WorkItemStatus {
    Active = 0,
    Preloaded = 1,
    Completed = 2,
}

export const WorkItemStatusSchema = z.enum(WorkItemStatus);

export enum ExternalTaskType {
    External = 0,
    WorkPackage = 1,
    Other = 2,
}

export const ExternalTaskTypeSchema = z.enum(ExternalTaskType);

export enum ProjectStatus {
    Active = 0,
    Completed = 1,
}

export const ProjectStatusSchema = z.enum(ProjectStatus);

/**
 * Gets the display label for a project status
 */
export function getProjectStatusLabel(projectStatus: ProjectStatus): string {
    switch (projectStatus) {
        case ProjectStatus.Active:
            return 'Active';
        case ProjectStatus.Completed:
            return 'Completed';
    }
}

// Cost entry type enum matching backend CostEntryType
export enum CostEntryType {
    Labour = 0,
    Materials = 1,
    Miscellaneous = 2,
}

export const CostEntryTypeSchema = z.enum(CostEntryType);

/**
 * Gets the display label for a cost entry type
 */
export function getCostEntryTypeLabel(entryType: CostEntryType): string {
    switch (entryType) {
        case CostEntryType.Labour:
            return 'Labour';
        case CostEntryType.Materials:
            return 'Materials';
        case CostEntryType.Miscellaneous:
            return 'Miscellaneous';
    }
}

/**
 * Gets the display label for a task type
 */
export function getWorkItemTypeLabel(workItemType: WorkItemType): string {
    switch (workItemType) {
        case WorkItemType.Contracted:
            return 'Contracted';
        case WorkItemType.Variation:
            return 'Variation';
        case WorkItemType.TrackerTask:
            return 'Tracker Task';
    }
}

/**
 * Gets the display label for a task status
 */
export function getWorkItemStatusLabel(workItemStatus: WorkItemStatus): string {
    switch (workItemStatus) {
        case WorkItemStatus.Active:
            return 'Active';
        case WorkItemStatus.Preloaded:
            return 'Preloaded';
        case WorkItemStatus.Completed:
            return 'Completed';
    }
}

export function getExternalTaskTypeLabel(
    externalTaskType: ExternalTaskType,
): string {
    switch (externalTaskType) {
        case ExternalTaskType.External:
            return 'External';
        case ExternalTaskType.WorkPackage:
            return 'Work Package';
        case ExternalTaskType.Other:
            return 'Other';
    }
}

export const BlobImageSchema = z.object({
    url: z.string(),
    blobName: z.string(),
    sizeBytes: z.number(),
});

export type BlobImage = z.infer<typeof BlobImageSchema>;

export const ImageFormValueSchema = z.object({
    imageBlobName: z.string().optional(),
    imageUrl: z.string().optional(),
    imageFile: z.instanceof(File).optional(),
    sizeBytes: z.number().optional(),
});

export type ImageFormValue = z.infer<typeof ImageFormValueSchema>;
